import React, { Component } from "react";
import DupontIconButton from "../DupontIconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare } from "@fortawesome/free-solid-svg-icons";

class ShareRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.shareHandler(this.props.node.data);
  }

  render() {
    const { node } = this.props;
    const isowner = node?.data?.is_owner;
    return (
      <div style={{ margin: 2 }}>
        <DupontIconButton
          onClick={this.invokeParentMethod}
          customClass={{ margin: "2px" }}
          disabled={!isowner}
        >
          <FontAwesomeIcon icon={faShare} color="white" />
        </DupontIconButton>
      </div>
    );
  }
}

export default ShareRenderer;
